/**
 * Register Service Worker for PWA
 */

import { markReminderInboxItemRead } from "../features/notifications/reminderInbox";

let swMessageHooked = false;

function hookServiceWorkerMessages() {
  if (swMessageHooked) return;
  if (!("serviceWorker" in navigator)) return;
  swMessageHooked = true;

  navigator.serviceWorker.addEventListener("message", (event) => {
    const data = event?.data;
    if (!data || typeof data !== "object") return;
    if (data.type === "reminder-read") {
      markReminderInboxItemRead(String(data.id || ""));
    }
  });
}

export async function registerServiceWorker(): Promise<ServiceWorkerRegistration | null> {
  if (!("serviceWorker" in navigator)) {
    console.warn("Service Workers are not supported");
    return null;
  }

  try {
    const registration = await navigator.serviceWorker.register("/sw.js", {
      scope: "/",
    });

    hookServiceWorkerMessages();
    console.log("Service Worker registered:", registration.scope);

    // Check for updates
    registration.addEventListener("updatefound", () => {
      const newWorker = registration.installing;
      if (newWorker) {
        newWorker.addEventListener("statechange", () => {
          if (newWorker.state === "installed" && navigator.serviceWorker.controller) {
            // New service worker available
            console.log("New service worker available");
          }
        });
      }
    });

    return registration;
  } catch (error) {
    console.error("Service Worker registration failed:", error);
    return null;
  }
}

/**
 * Unregister service worker (for development)
 */
export async function unregisterServiceWorker(): Promise<boolean> {
  if (!("serviceWorker" in navigator)) return false;

  try {
    const registration = await navigator.serviceWorker.ready;
    const result = await registration.unregister();
    console.log("Service Worker unregistered:", result);
    return result;
  } catch (error) {
    console.error("Service Worker unregistration failed:", error);
    return false;
  }
}
